<template>
    <div>
        <!-- <div class="middleware-game" v-if="!isLoading"></div> -->
        <Loader v-if="isLoading" loaderStyle="circle" ></Loader>
    </div>
</template>
<script>
import firebase from "firebase";
// import nextStep from "../../helpers/nextStep"
import * as steps from "../../helpers/currentStepVerify"
import Loader from '../../components/Alerts/Loader'
import flowApi from "../../api/flowApi"
import createProcess from '../../helpers/createProcess';
export default {
    data(){
        return{
            isLoading: true
        }
    },
    components: {Loader},
    async created(){
        const redirectGame = await localStorage.getItem('game-redirect')
        const workspaceId = localStorage.getItem('workspaceId')
        const user = await JSON.parse(localStorage.getItem('user'))
        const token = await localStorage.getItem('token')
        if(redirectGame != 'repense' && redirectGame != 'decode'){
            let flowData = await steps.getFlowData(user.id, workspaceId)
            if(flowData.length == 0) flowData = await createProcess(user.id, workspaceId, user.name)

            const currentStep = await steps.getCurrentSteps(flowData.steps)
            // console.log("currentStep: ", currentStep)
            if(currentStep ==  "finished") window.location.replace(`${flowData.steps[flowData.current].url}?uid=${user.id}&workspaceId=${workspaceId}&token=${token}`)
            if(!currentStep.currentStep && flowData.steps[flowData.current].url) window.location.replace(`${flowData.steps[flowData.current].url}?uid=${user.id}&workspaceId=${workspaceId}&token=${token}`)
            window.location.replace(`${currentStep.currentStep.url}?uid=${user.id}&workspaceId=${workspaceId}&token=${token}`)
            return
        }
        redirectGame == 'repense' ? 
            window.location.replace(`${process.env.VUE_APP_HOST_REPENSE}/redirect-auth?uid=${user.id}&workspaceId=${workspaceId}&token=${token}`) : 
            window.location.replace(`${process.env.VUE_APP_HOST_DECODE}/redirect-auth?uid=${user.id}&workspaceId=${workspaceId}&token=${token}`)
        
    }
}
</script>
<style lang="scss" scoped>

</style>